// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.pageNotFound_dashboard__0TP5u {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.pageNotFound_dashboardContain__yud5h {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_dashboardContain__yud5h,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_dashboard__0TP5u,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_cont2__EI6Fp {
  background-Color: #0f1824;
}

.pageNotFound_top_header__CbMdW .pageNotFound_top_header_inner__Yqzkv {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.pageNotFound_cont2__EI6Fp {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.pageNotFound_subLink__zyAJ6 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.pageNotFound_footer__81doL {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.pageNotFound_bodythemelight__9C0zJ {
  background-color: #fff;
  padding-top: 90px;
}

.pageNotFound_bodythemedark__izgZ0 {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.pageNotFound_headerthemelight__nogyG {
  background-color: #fff;
}

.pageNotFound_headerthemedark__n03qG {
  background-color: #132337;
}

.pageNotFound_top_header__CbMdW {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.pageNotFound_menuthemelight__uQTtA {
  background-color: #fff;
}

.pageNotFound_menuthemedark__9swPb {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.pageNotFound_menulinklight__iCnH0 span {
  color: #666666 !important;
}

.pageNotFound_menulinklight__iCnH0 a {
  color: #CBCBCB !important;
}

.pageNotFound_menulinklight__iCnH0:hover span, .pageNotFound_menulinklight__iCnH0:hover a {
  color: #fff !important;
}

.pageNotFound_menulinkdarkSelected__GzD0b {
  background-color: #1c2e45;
  color: #fff;
}

.pageNotFound_menuthemelight__uQTtA .pageNotFound_menulinklightSelected__qDVX8 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.pageNotFound_menulinkdark__Fcqkt {
  color: #60677e !important;
}

.pageNotFound_menulinklight__iCnH0:hover {
  color: #fff !important;
  background-color: #205440;
}

.pageNotFound_menulinkdark__Fcqkt:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.pageNotFound_headinglight__aU2u3 {
  color: #60677e;
}

.pageNotFound_headingdark__pzwfB {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.pageNotFound_searchboxlight__Pp7Yy {
  background-color: #fff;
  border: none;
}

.pageNotFound_searchboxdark__xEfh- {
  background-color: #132337;
  color: #fff;
  border: none;
}

.pageNotFound_searchboxdark__xEfh-::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.pageNotFound_tableheadlight__6cDbl {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.pageNotFound_tableheadlight__6cDbl th {
  color: #fff;
}

thead .pageNotFound_tableheadlight__6cDbl th:first-child,
thead .pageNotFound_tableheaddark__o6KpO th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .pageNotFound_tableheadlight__6cDbl th:last-child,
thead .pageNotFound_tableheaddark__o6KpO th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.pageNotFound_table__8c81O.pageNotFound_table-borderless__S2usL {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.pageNotFound_tableheaddark__o6KpO {
  background-color: #1e1e2d;
  color: #fff;
}

.pageNotFound_table-borderless__S2usL tr:nth-child(even) {
  background-color: #F9FAFB;
}

.pageNotFound_table-borderless__S2usL .pageNotFound_left-section__nYWHy {
  padding-top: 10px;
}

.pageNotFound_tablebodylight__zbx9W td,
.pageNotFound_tablebodydark__5345K td {
  padding: 1rem 1rem !important;
}

.pageNotFound_tablebodylight__zbx9W {
  background-color: #fff;
}
.pageNotFound_tablebodylight__zbx9W:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.pageNotFound_tablebodydark__5345K {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.pageNotFound_tablebodydark__5345K:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.pageNotFound_paginationlight__5-m1Y {
  color: #60677e !important;
  font-size: 13px !important;
}

.pageNotFound_paginationdark__0djFl {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.pageNotFound_formthemelight__BnzOv {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.pageNotFound_formthemedark__k43uf {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.pageNotFound_formthemedark__k43uf ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.pageNotFound_viewformlight__rI6NH {
  background-color: #f3f6f9;
}

.pageNotFound_permissionboxlight__kVZ9Z {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.pageNotFound_permissionboxdark__eLcKA {
  background-color: #151521;
  border: solid 1px #242434;
}

.pageNotFound_errormsgclr__X2vxQ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.pageNotFound_graphclrlight__kk-pp {
  background-color: #fff;
}

.pageNotFound_graphclrdark__HSI92 {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#pageNotFound_card1bglight__V5atL {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card1bglight__V5atL:hover {
  background: #f7fffc;
}

#pageNotFound_card1bgdark__lYsBK {
  background: #392f28;
}

#pageNotFound_card1bgdark__lYsBK:hover {
  background: #f7fffc;
}

#pageNotFound_card2bglight__mXhao {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card2bglight__mXhao:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#pageNotFound_card2bgdark__E-LAP {
  background: #1c3238;
}

#pageNotFound_card3bglight__LxOFZ {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card3bglight__LxOFZ:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#pageNotFound_card3bgdark__yN\\+MZ {
  background: #3a2434;
}

#pageNotFound_card4bglight__g176N {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card4bglight__g176N:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#pageNotFound_card4bgdark__huDb5 {
  background: #2f264f;
}

#pageNotFound_card1bgdark__lYsBK a, #pageNotFound_card1bgdark__lYsBK p,
#pageNotFound_card2bgdark__E-LAP a, #pageNotFound_card2bgdark__E-LAP p,
#pageNotFound_card3bgdark__yN\\+MZ a, #pageNotFound_card3bgdark__yN\\+MZ p,
#pageNotFound_card4bgdark__huDb5 a, #pageNotFound_card4bgdark__huDb5 p {
  color: #fff;
}

/* 
Action button theme
*/
.pageNotFound_actionbtnlight__MOwsn {
  color: rgba(70, 71, 91, 0.8705882353);
}

.pageNotFound_actionbtndark__W4WOX {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.pageNotFound_profiledropdownlight__67WTq {
  background-color: #fff;
}

.pageNotFound_profiledropdowndark__WyM1p {
  background-color: #151521;
}

.pageNotFound_settingsection__1httz #pageNotFound_addform__qq8S5.pageNotFound_formthemedark__k43uf .pageNotFound_savebtn__AxlOn {
  background-color: #0a2574;
  color: #fff;
}

#pageNotFound_addform__qq8S5.pageNotFound_formthemedark__k43uf .pageNotFound_savebtn__AxlOn {
  background-color: #0a2574;
  color: #fff;
}

.pageNotFound_profile_conatiner__tORcl {
  border-radius: 5px !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_ag-theme-alpine__O7mDj .pageNotFound_ag-row__2yX73 {
  background: #000 !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_formbtn__2z\\+SQ {
  background-color: #0a2574;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_resetbtn__lAzFq {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_resetbtn__lAzFq:hover {
  background-color: #0a2574;
}

.pageNotFound_headingdark__pzwfB span {
  background-color: #132337;
}

.pageNotFound_resetbtn__lAzFq {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.pageNotFound_resetbtn__lAzFq:hover,
.pageNotFound_resetbtn__lAzFq:active,
.pageNotFound_resetbtn__lAzFq:focus {
  background-color: #205440;
  color: #fff;
}

.pageNotFound_addBtn__rwE\\+l {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.pageNotFound_addBtn__rwE\\+l svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.pageNotFound_addBtn__rwE\\+l:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.pageNotFound_cust_addBtn__TnOt1.pageNotFound_addBtn__rwE\\+l svg {
  top: 2px;
}

.pageNotFound_deleteBtn__XLyVi {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.pageNotFound_deleteBtn__XLyVi {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.pageNotFound_deleteBtn__XLyVi:active, .pageNotFound_deleteBtn__XLyVi:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.pageNotFound_deleteBtn__XLyVi svg {
  position: relative;
  top: -2px;
}

.pageNotFound_deleteBtn__XLyVi:hover,
.pageNotFound_deleteBtn__XLyVi:active,
.pageNotFound_deleteBtn__XLyVi:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.pageNotFound_confirmBtn__fwsol {
  background-color: #205440;
}

.pageNotFound_confirmBtn__fwsol:hover,
.pageNotFound_confirmBtn__fwsol:active,
.pageNotFound_confirmBtn__fwsol:focus {
  background-color: #205440;
}

.pageNotFound_confirmBtn__fwsol svg {
  top: 0;
}

.pageNotFound_back_dlt__WlmRy {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_modal-body__F3rpo {
  padding: 25px;
  text-align: center;
}

.pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_delet_icon__wLV3L {
  margin-bottom: 11px;
}

.pageNotFound_delPopContainer__jG\\+ZJ p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.pageNotFound_arrowback__oGXcu svg {
  fill: #000;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_arrowback__oGXcu {
  background-color: #0a2574;
  color: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_arrowback__oGXcu svg {
  fill: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_drpdwn_btn__pzqyu {
  background-color: #132337;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_empname__C\\+FQL {
  color: #60677e !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_navitemli__bTqs5 a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingsgeneral__6vqVQ,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingslinks__LBkg9:hover {
  background-color: #0a2574;
  color: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingslinks__LBkg9 {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .pageNotFound_tableheadlight__6cDbl th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .pageNotFound_dashboard__0TP5u {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #pageNotFound_dashboardcont2__v186B {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .pageNotFound_sectionright__enb5k {
    float: unset !important;
  }
  .pageNotFound_dashboard__0TP5u {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .pageNotFound_cont2__EI6Fp {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .pageNotFound_bodythemelight__9C0zJ, .pageNotFound_bodythemedark__izgZ0 {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .pageNotFound_exer_modal_contain__EGPxS .pageNotFound_modal-dialog__6f-OB {
    max-width: 1055px;
  }
  .pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_modal-dialog__6f-OB {
    max-width: 350px;
  }
}
#pageNotFound_notfoundbg__QT9Fg {
  height: 100vh;
}

.pageNotFound_centerbox__93O8u {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #1d1d1d;
  align-items: center;
  height: max-content;
}

.pageNotFound_imgdiv__b7eTp {
  justify-content: center;
  display: flex;
}

.pageNotFound_pagenotimage__P-7Vt {
  width: 250px;
  height: 200px;
}

.pageNotFound_pagenotfoundhead__p8c3e {
  font-size: 30px;
  color: #28305f;
  text-align: center;
  margin-top: 10px;
}

.pageNotFound_pagenotfoundpara__sT4fn {
  font-size: 18px;
  color: #28305f;
  text-align: center;
}

.pageNotFound_btnsection__2I-9O {
  display: flex;
  justify-content: center;
}

.pageNotFound_gohomebtn__aPCJt {
  background-color: #28305f;
  color: #fff;
  border: none;
  padding: 6px 20px 6px 20px;
  border-radius: 6px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/404/pageNotFound.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EACI,aAAA;AAopBJ;;AAlpBA;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cDqCU;ECpCV,mBAAA;EACA,mBAAA;AAopBJ;;AAjpBA;EACI,uBAAA;EACA,aAAA;AAopBJ;;AAjpBA;EACI,YAAA;EACA,aAAA;AAopBJ;;AAlpBA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAqpBJ;;AAnpBA;EACI,eAAA;EAEA,cAAA;EACA,kBAAA;AAqpBJ;;AAlpBA;EACI,aAAA;EACA,uBAAA;AAqpBJ;;AAnpBA;EACI,yBAAA;EACA,WDGU;ECFV,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AAspBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n#notfoundbg{\n    height: 100vh;\n}\n.centerbox{\n  \n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: $black-color;\n    align-items: center;\n    height: max-content;\n}\n\n.imgdiv{\n    justify-content: center;\n    display: flex;\n}\n\n.pagenotimage{\n    width: 250px;\n    height: 200px;\n}\n.pagenotfoundhead{\n    font-size: 30px;\n    color: #28305f;\n    text-align: center;\n    margin-top: 10px;\n}\n.pagenotfoundpara{\n    font-size: 18px;\n     \n    color: #28305f;\n    text-align: center;\n}\n\n.btnsection{\n    display: flex;\n    justify-content: center;\n}\n.gohomebtn{\n    background-color: #28305f;\n    color: $white-color;\n    border: none;\n    padding: 6px 20px 6px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n     \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `pageNotFound_dashboard__0TP5u`,
	"dashboardContain": `pageNotFound_dashboardContain__yud5h`,
	"bodythemedark": `pageNotFound_bodythemedark__izgZ0`,
	"cont2": `pageNotFound_cont2__EI6Fp`,
	"top_header": `pageNotFound_top_header__CbMdW`,
	"top_header_inner": `pageNotFound_top_header_inner__Yqzkv`,
	"subLink": `pageNotFound_subLink__zyAJ6`,
	"footer": `pageNotFound_footer__81doL`,
	"bodythemelight": `pageNotFound_bodythemelight__9C0zJ`,
	"headerthemelight": `pageNotFound_headerthemelight__nogyG`,
	"headerthemedark": `pageNotFound_headerthemedark__n03qG`,
	"menuthemelight": `pageNotFound_menuthemelight__uQTtA`,
	"menuthemedark": `pageNotFound_menuthemedark__9swPb`,
	"menulinklight": `pageNotFound_menulinklight__iCnH0`,
	"menulinkdarkSelected": `pageNotFound_menulinkdarkSelected__GzD0b`,
	"menulinklightSelected": `pageNotFound_menulinklightSelected__qDVX8`,
	"menulinkdark": `pageNotFound_menulinkdark__Fcqkt`,
	"headinglight": `pageNotFound_headinglight__aU2u3`,
	"headingdark": `pageNotFound_headingdark__pzwfB`,
	"searchboxlight": `pageNotFound_searchboxlight__Pp7Yy`,
	"searchboxdark": `pageNotFound_searchboxdark__xEfh-`,
	"tableheadlight": `pageNotFound_tableheadlight__6cDbl`,
	"tableheaddark": `pageNotFound_tableheaddark__o6KpO`,
	"table": `pageNotFound_table__8c81O`,
	"table-borderless": `pageNotFound_table-borderless__S2usL`,
	"left-section": `pageNotFound_left-section__nYWHy`,
	"tablebodylight": `pageNotFound_tablebodylight__zbx9W`,
	"tablebodydark": `pageNotFound_tablebodydark__5345K`,
	"paginationlight": `pageNotFound_paginationlight__5-m1Y`,
	"paginationdark": `pageNotFound_paginationdark__0djFl`,
	"formthemelight": `pageNotFound_formthemelight__BnzOv`,
	"formthemedark": `pageNotFound_formthemedark__k43uf`,
	"viewformlight": `pageNotFound_viewformlight__rI6NH`,
	"permissionboxlight": `pageNotFound_permissionboxlight__kVZ9Z`,
	"permissionboxdark": `pageNotFound_permissionboxdark__eLcKA`,
	"errormsgclr": `pageNotFound_errormsgclr__X2vxQ`,
	"graphclrlight": `pageNotFound_graphclrlight__kk-pp`,
	"graphclrdark": `pageNotFound_graphclrdark__HSI92`,
	"card1bglight": `pageNotFound_card1bglight__V5atL`,
	"card1bgdark": `pageNotFound_card1bgdark__lYsBK`,
	"card2bglight": `pageNotFound_card2bglight__mXhao`,
	"card2bgdark": `pageNotFound_card2bgdark__E-LAP`,
	"card3bglight": `pageNotFound_card3bglight__LxOFZ`,
	"card3bgdark": `pageNotFound_card3bgdark__yN+MZ`,
	"card4bglight": `pageNotFound_card4bglight__g176N`,
	"card4bgdark": `pageNotFound_card4bgdark__huDb5`,
	"actionbtnlight": `pageNotFound_actionbtnlight__MOwsn`,
	"actionbtndark": `pageNotFound_actionbtndark__W4WOX`,
	"profiledropdownlight": `pageNotFound_profiledropdownlight__67WTq`,
	"profiledropdowndark": `pageNotFound_profiledropdowndark__WyM1p`,
	"settingsection": `pageNotFound_settingsection__1httz`,
	"addform": `pageNotFound_addform__qq8S5`,
	"savebtn": `pageNotFound_savebtn__AxlOn`,
	"profile_conatiner": `pageNotFound_profile_conatiner__tORcl`,
	"ag-theme-alpine": `pageNotFound_ag-theme-alpine__O7mDj`,
	"ag-row": `pageNotFound_ag-row__2yX73`,
	"formbtn": `pageNotFound_formbtn__2z+SQ`,
	"resetbtn": `pageNotFound_resetbtn__lAzFq`,
	"addBtn": `pageNotFound_addBtn__rwE+l`,
	"cust_addBtn": `pageNotFound_cust_addBtn__TnOt1`,
	"deleteBtn": `pageNotFound_deleteBtn__XLyVi`,
	"confirmBtn": `pageNotFound_confirmBtn__fwsol`,
	"back_dlt": `pageNotFound_back_dlt__WlmRy`,
	"delPopContainer": `pageNotFound_delPopContainer__jG+ZJ`,
	"modal-body": `pageNotFound_modal-body__F3rpo`,
	"delet_icon": `pageNotFound_delet_icon__wLV3L`,
	"arrowback": `pageNotFound_arrowback__oGXcu`,
	"drpdwn_btn": `pageNotFound_drpdwn_btn__pzqyu`,
	"empname": `pageNotFound_empname__C+FQL`,
	"navitemli": `pageNotFound_navitemli__bTqs5`,
	"tabnavli": `pageNotFound_tabnavli__0bRdR`,
	"settingsgeneral": `pageNotFound_settingsgeneral__6vqVQ`,
	"settingslinks": `pageNotFound_settingslinks__LBkg9`,
	"dashboardcont2": `pageNotFound_dashboardcont2__v186B`,
	"sectionright": `pageNotFound_sectionright__enb5k`,
	"exer_modal_contain": `pageNotFound_exer_modal_contain__EGPxS`,
	"modal-dialog": `pageNotFound_modal-dialog__6f-OB`,
	"notfoundbg": `pageNotFound_notfoundbg__QT9Fg`,
	"centerbox": `pageNotFound_centerbox__93O8u`,
	"imgdiv": `pageNotFound_imgdiv__b7eTp`,
	"pagenotimage": `pageNotFound_pagenotimage__P-7Vt`,
	"pagenotfoundhead": `pageNotFound_pagenotfoundhead__p8c3e`,
	"pagenotfoundpara": `pageNotFound_pagenotfoundpara__sT4fn`,
	"btnsection": `pageNotFound_btnsection__2I-9O`,
	"gohomebtn": `pageNotFound_gohomebtn__aPCJt`
};
export default ___CSS_LOADER_EXPORT___;
